export class WorkspacePermissions {
  /**
   * Menu View Permissions
   */

  public static readonly MENU_VIEW = {
    HOME: "menu:home:view",
    DEDUCTIONS: "menu:deductions:view",
    APPROVALS: "menu:approvals:view",
    INTELLI_UPLOAD: "menu:intelliUpload:view",
    CONVERSATIONS: "menu:conversations:view",
    ANALYTICS: "menu:analytics:view",
    USERS: "menu:users:view",
    ACCOUNTING: "menu:accounting:view",
    TRADE_PROMOTIONS: "menu:tradePromotions:view",
    DISPUTES_TRACKING: "menu:disputes:tracking:view",
    DOCUMENT_REPOSITORY: "menu:documentRepository:view",
  };

  /**
   * Home / To-Do
   */
  public static readonly HOME_TODO_VIEW = "home:todo:view";

  /**
   * User Management
   */
  public static readonly USER_MANAGEMENT_VIEW = "user-management:view";
  public static readonly USER_MANAGEMENT_ADD = "user-management:add";
  public static readonly USER_MANAGEMENT_EDIT = "user-management:edit";

  /**
   * Conversations
   */
  public static readonly CONVERSATIONS_VIEW = "conversations:view";
  public static readonly CONVERSATIONS_ADD = "conversations:add";
  public static readonly CONVERSATIONS_EDIT = "conversations:edit";

  /**
   * Remittances
   */
  public static readonly REMITTANCE_IMPORT_CSV = "remittance:import:csv";

  /**
   * Deductions
   */
  public static readonly DEDUCTIONS_VIEW = "deductions:view";
  public static readonly DEDUCTIONS_ADD = "deductions:add";
  public static readonly DEDUCTIONS_EDIT = "deductions:edit";
  public static readonly DEDUCTIONS_DISPUTE = "deduction:raise:dispute";
  public static readonly DEDUCTIONS_SEND_APPROVAL = "deduction:send:approval";
  public static readonly DEDUCTIONS_APPROVAL_VIEW = "deduction:approval:view";
  public static readonly DEDUCTIONS_APPROVAL_ACTION = "deduction:approval:action";
  
  public static readonly DEDUCTIONS_STATUS_AWAITING_RESPONSE = "deduction:status:awaiting-response";
  public static readonly DEDUCTIONS_STATUS_DISPUTE_NEEDED = "deduction:status:dispute-needed";
  public static readonly DEDUCTIONS_STATUS_VOID = "deduction:status:void";
  public static readonly DEDUCTIONS_STATUS_WRITTEN_OFF = "deduction:status:written-off";
  public static readonly DEDUCTIONS_DISPUTE_APPROVE = "deduction:dispute:approve";
  public static readonly DEDUCTIONS_DISPUTE_REJECT = "deduction:dispute:reject";
  public static readonly DEDUCTIONS_STATUS_REOPEN = "deduction:status:reopen";

  /**
   * Charge Breakdown
   */
  public static readonly DEDUCTIONS_CHARGE_BREAKDOWN_ADD = "deduction:chargeBreakdown:add";

  /**
   * Analytics
   */
  public static readonly ANALYTICS_VIEW = "analytics:view";
  public static readonly ANALYTICS_ADD = "analytics:add";
  public static readonly ANALYTICS_EDIT = "analytics:edit";
  public static readonly ANALYTICS_SHARE_PUBLIC = "analytics:share:public";

  /**
   * Notification
   */
  public static readonly NOTIFICATION_VIEW = "notification:view";

  /**
   * Feedback
   */
  public static readonly FEEDBACK_ADD = "feedback:add";

  /**
   * Document Management
   */
  public static readonly DEDUCTION_DOCUMENT_VIEWER = "deduction:document:viewer";
  public static readonly DEDUCTION_DOCUMENT_ADD = "deduction:document:add";
  public static readonly DEDUCTION_DOCUMENT_DELETE = "deduction:document:delete";

  /**
   * Activity
   */
  public static readonly DEDUCTION_ACTIVITY_VIEW = "deduction:activity:view";
  public static readonly DEDUCTION_ACTIVITY_EXPORT = "deduction:activity:export";

  /**
   * Deduction Incomplete
   */
  public static readonly DEDUCTION_INCOMPLETE_VIEW = "deduction:incomplete:view";
  public static readonly DEDUCTION_INCOMPLETE_RESOLVE_BACKUP_REQUEST = "deduction:incomplete:resolve:backup:request";
  public static readonly DEDUCTION_INCOMPLETE_RESOLVE_BACKUP_UPLOAD = "deduction:incomplete:resolve:backup:upload";
  public static readonly DEDUCTION_INCOMPLETE_RESOLVE_BACKUP_MANUAL = "deduction:incomplete:resolve:backup:manual";

  /**
   * IntelliUpload
   */
  public static readonly INTELLI_UPLOAD_UPLOAD = "intelliUpload:upload";

  /**
   *
   * Purge Data
   */
  public static readonly PURGE_TRANSACTIONAL_DATA = "tenant:transactions:purge";

  /**
   * Accounting
   * ACCOUNTING_VIEW / ACCOUNTING_PUSH are deprecated umbrella keys kept for one-release JWT fallback.
   */
  public static readonly ACCOUNTING_VIEW = "accounting:view";
  public static readonly ACCOUNTING_PUSH = "accounting:push";
  public static readonly ACCOUNTING_CREDIT_MEMO_VIEW = "accounting:creditMemo:view";
  public static readonly ACCOUNTING_CREDIT_MEMO_PUSH = "accounting:creditMemo:push";
  public static readonly ACCOUNTING_JOURNAL_ENTRY_VIEW = "accounting:journalEntry:view";
  public static readonly ACCOUNTING_JOURNAL_ENTRY_PUSH = "accounting:journalEntry:push";

  /**
   * Trade Promotions
   */
  public static readonly TRADE_PROMOTIONS_VIEW = "tradePromotions:view";
  public static readonly TRADE_PROMOTIONS_ADD = "tradePromotions:add";
  public static readonly TRADE_PROMOTIONS_ADD_UI = "tradePromotions:add:ui";
  public static readonly TRADE_PROMOTIONS_EDIT = "tradePromotions:edit";
  public static readonly TRADE_PROMOTIONS_DELETE = "tradePromotions:delete";

  /**
   * Dispute Tracking
   */
  public static readonly DISPUTES_TRACKING_VIEW = "disputes:tracking:view";
  public static readonly DISPUTES_TRACKING_COMMENTS_VIEW = "disputes:tracking:comments:view";

  /**
   * Document Repository
   */
  public static readonly DOCUMENT_REPOSITORY_VIEW = "documentRepository:view";
  public static readonly DOCUMENT_REPOSITORY_PROCESS = "documentRepository:process";

  /**
   *  Credits
   */
  public static readonly CREDITS_VIEW = "credits:view";
  public static readonly CREDIT_DOCUMENT_VIEWER = "credit:document:viewer";
  public static readonly CREDIT_DOCUMENT_ADD = "credit:document:add";
  public static readonly CREDIT_DOCUMENT_DELETE = "credit:document:delete";
}
